export enum StepStatus {
  COMPLETED = 'COMPLETED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface MilestoneIssueDetails {
  assignee: string | null;
  startDate: string;
  overdue: string | number | null;
}

export interface Milestone {
  milestoneName: string;
  status: StepStatus;
  details?: MilestoneIssueDetails;
  detailsList?: MilestoneIssueDetails[];
  childElementsIds: string[] | null;
}

export interface ProcessData {
  processDefinition: string;
  processBusinessKey: string;
  startedAt: string;
  createdBy?: string;
  milestonesDetails: Milestone[];
  additionalInfo?: {
    type: string;
    startDate: string;
    endDate: string;
  };
}
